import { render, staticRenderFns } from "./TheHeaderLandingPage.vue?vue&type=template&id=74162258&scoped=true"
import script from "./TheHeaderLandingPage.vue?vue&type=script&lang=js"
export * from "./TheHeaderLandingPage.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderLandingPage.vue?vue&type=style&index=0&id=74162258&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74162258",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74162258')) {
      api.createRecord('74162258', component.options)
    } else {
      api.reload('74162258', component.options)
    }
    module.hot.accept("./TheHeaderLandingPage.vue?vue&type=template&id=74162258&scoped=true", function () {
      api.rerender('74162258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TheHeader/TheHeaderLandingPage.vue"
export default component.exports